import { Link } from 'react-router';
import { Fragment } from 'react';
import { useI18n } from '@/client/i18n/I18nContext';
import { lp } from '@/client/i18n/locale';

export interface Crumb {
  name: string;
  path?: string;
}

export function Breadcrumb({ items }: { items: Crumb[] }) {
  const { t } = useI18n();
  return (
    <nav aria-label={t('a11y.breadcrumb')} className="breadcrumb">
      {items.map((c, i) => (
        <Fragment key={`${c.name}-${i}`}>
          {c.path ? <Link to={lp(c.path)}>{c.name}</Link> : <span>{c.name}</span>}
          {i < items.length - 1 ? <span aria-hidden>·</span> : null}
        </Fragment>
      ))}
    </nav>
  );
}
